<template>
  <div class="bg-(--brand-secondary) py-2 px-4 sticky top-0 z-10">
    <div class="flex items-center justify-center lg:justify-between max-w-(--max-width) mx-auto">

      <div class="space-x-1 hidden lg:flex">
        <a href="#about"
           class="hover:text-(--brand-primary) px-4 py-3 font-medium text-base">About</a>
        <a href="#how-it-works"
           class="hover:text-(--brand-primary) px-4 py-3 font-medium text-base">How It
          Works</a>
      </div>
      <div class="flex-shrink-0">
        <img src="@/assets/images/logo.webp" alt="Claims For Cars Logo"
             class="w-30 sm:w-[136px]">
      </div>
      <div class="space-x-6 hidden lg:flex">
        <a href="#current-claims"
           class="hover:text-(--brand-primary) px-4 py-3 font-medium text-base">Current
          Claims</a>
        <a href="#faq" class="hover:text-(--brand-primary) px-4 py-3 font-medium text-base">FAQ</a>
      </div>
    </div>
  </div>
</template>
